import React from "react";

function FooterColores () {
    return (
    <div className="col-sm-12 col-md-12 col-lg-12 height10 contenedorModal">
        <div className="azulFooter"></div>
        <div className="rojoFooter"></div>
        <div className="amarilloFooter"></div>
        <div className="verdeFooter"></div>
    </div>
    )
}

export default FooterColores;